import React, { useEffect, useState } from "react";
import { showFormErrors } from "../../../helpers/showFormErrors";
import CustomInput from "../../../components/form/CustomInput";
import CustomSelect from "../../../components/form/CustomSelect";
import CustomButton from "../../../components/form/CustomButton";
import { getStatuses, trailerTrucksResource } from "../../../helpers/configRoutes/backend_helper";
import { useDispatch } from "react-redux";
import { reset_stop } from "../../../store/loads/action";

const StepTowForm = ({
    validation,
    setNewStop,
    loadTrailerId,
    isEditing = false,
    onCancel,
    emptyMilesStatusId,
}) => {
    const dispatch = useDispatch();

    const [statuses, setStatuses] = useState([]);
    const [trailers, setTrailers] = useState([]);

    const isEmptyMilesStop = Number(validation?.values?.status_id) === Number(emptyMilesStatusId);

    const resetStop = () => {
        validation.resetForm();
        dispatch(reset_stop());
        setNewStop(false);
        onCancel?.();
    };

    useEffect(() => {
        const getCatalogs = async () => {
            const statusesResponse = await getStatuses({ params: { model: "Stop" } });
            setStatuses(statusesResponse.statuses || []);

            const trailersResponse = await trailerTrucksResource("get", {
                params: { select: true },
            });
            setTrailers(trailersResponse?.items || []);
        };
        getCatalogs();
    }, []);

    useEffect(() => {
        if (!validation?.values?.trailer_id && loadTrailerId) {
            validation.setFieldValue("trailer_id", loadTrailerId, false);
        }
    }, [loadTrailerId, validation]);

    return (
        <form
            onSubmit={(e) => {
                e.preventDefault();
                validation.handleSubmit();
                showFormErrors(validation);
                return false;
            }}
        >
            <div className="grid grid-cols-2 gap-4 p-2">
                <CustomSelect
                    label="Status"
                    options={statuses}
                    name="status_id"
                    labelClassName={"text-base text-[#ADADAD]"}
                    className={"mr-2"}
                    error={validation?.errors?.status_id}
                    value={validation?.values?.status_id}
                    handleChange={(e) => {
                        const selectedStatus = statuses.find((s) => s.id === parseInt(e.target.value, 10));
                        validation.setFieldValue("status", selectedStatus);
                        validation.setFieldValue("status_id", e.target.value);

                        if (Number(e.target.value) === Number(emptyMilesStatusId)) {
                            validation.setFieldValue("mile", 0);
                        }
                    }}
                />
                <CustomInput
                    label="Mile"
                    type="text"
                    name="mile"
                    labelClassName="text-[14px] text-[#ADADAD] whitespace-nowrap"
                    error={validation?.errors?.mile}
                    value={validation?.values?.mile}
                    handleChange={isEmptyMilesStop ? () => {} : validation.handleChange}
                    disabled={isEmptyMilesStop}
                />
                <CustomSelect
                    label="Trailer"
                    options={trailers}
                    name="trailer_id"
                    labelClassName={"text-base text-[#ADADAD]"}
                    className={"mr-2"}
                    error={validation?.errors?.trailer_id}
                    value={validation?.values?.trailer_id}
                    handleChange={validation.handleChange}
                    placeholder="Optional if each stop already has a trailer"
                />
                <div className="grid grid-cols-2 ">
                    <CustomInput
                        label="Start Date"
                        name="date"
                        type={"date"}
                        labelClassName="text-[14px] text-[#ADADAD] whitespace-nowrap"
                        error={validation?.errors?.date}
                        value={validation?.values?.date}
                        handleChange={validation.handleChange}
                    />
                    <CustomInput
                        label="Start Time"
                        name="load_time"
                        type={"time"}
                        labelClassName="text-[14px] text-[#ADADAD] whitespace-nowrap"
                        error={validation?.errors?.load_time}
                        value={validation?.values?.load_time}
                        handleChange={validation.handleChange}
                    />
                </div>
                <div className="grid grid-cols-2 ">
                    <CustomInput
                        label="End Date"
                        name="delivery_date"
                        type={"date"}
                        labelClassName="text-[14px] text-[#ADADAD] whitespace-nowrap"
                        error={validation?.errors?.delivery_date}
                        value={validation?.values?.delivery_date}
                        handleChange={validation.handleChange}
                    />
                    <CustomInput
                        label="End Time"
                        name="delivery_time"
                        type={"time"}
                        labelClassName="text-[14px] text-[#ADADAD] whitespace-nowrap"
                        error={validation?.errors?.delivery_time}
                        value={validation?.values?.delivery_time}
                        handleChange={validation.handleChange}
                    />
                </div>
            </div>
            <div className="flex items-center justify-center gap-3 p-6 rounded-b border-slate-200">
                <CustomButton
                    type={"submit"}
                    className="w-full lg:w-[20%]"
                >
                    {isEditing ? "Save Stop" : "Add Stop"}
                </CustomButton>

                <CustomButton
                    onClick={resetStop}
                    type={"button"}
                    variant="outline"
                    className="w-full lg:w-[20%]"
                >
                    Cancel
                </CustomButton>
            </div>
        </form>
    );
};

export default StepTowForm;
